import React, { useEffect, useState } from "react";
import { Upload, Modal, Button, message, Input, Spin } from "antd";
import {
  InboxOutlined,
  DeleteOutlined,
  UploadOutlined,
  DownloadOutlined,
  EditOutlined,
} from "@ant-design/icons";
import Instance from "../../../AxiosConfig";
import { useParams } from "react-router-dom";
import { Pagination } from "antd";
const { Dragger } = Upload;

export const NdaDocuments = () => {
  const { id: companyId } = useParams();

  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [limit] = useState(20);
  const [total, setTotal] = useState(0);
  const [uploading, setUploading] = useState(false);
  // const [search, setSearch] = useState("");

  // ✅ Upload Modal
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [fileList, setFileList] = useState([]);

  // 🔥 Duplicate Handling States
  const [duplicateModal, setDuplicateModal] = useState(false);
  const [duplicateFiles, setDuplicateFiles] = useState([]);
  const [pendingFiles, setPendingFiles] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [editingName, setEditingName] = useState("");
  // ================= FETCH =================
  const fetchDocuments = async () => {
    if (!companyId) return;

    setLoading(true);
    try {
      const res = await Instance.get(`/company/${companyId}/ndas`, {
        params: {
          page,
          limit
        },
      });
console.log("nda Documents API Response:", res.data); // Debug log
      setDocuments(res.data.ndas || []);
      setTotal(res.data.total || 0); // ✅ important
    } catch {
      message.error("Failed to load documents");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDocuments();
  }, [companyId, page]);

  // ================= UPLOAD =================
  const uploadToServer = async (files, options = {}) => {
    const fd = new FormData();

    files.forEach((file) => fd.append("documents", file.originFileObj));

    fd.append("replaceDuplicate", options.replaceDuplicate || "false");
    fd.append("skipDuplicateCheck", options.skipDuplicateCheck || "false");

    try {
      // ✅ NO HEADERS HERE
      await Instance.post(`/company/${companyId}/ndas`, fd);

      message.success("Uploaded successfully");
      setIsModalOpen(false);
      setFileList([]);
      fetchDocuments();
    } catch (err) {
      console.log("Upload error:", err);

      if (err.response?.status === 409) {
        setDuplicateFiles(err.response.data.duplicates || []);
        setPendingFiles(files);
        setDuplicateModal(true);
      } else {
        const errorMsg =
          err.response?.data?.message || // ✅ backend message
          err.response?.data?.error || // fallback
          "Upload failed"; // default

        message.error(errorMsg);
      }
    }
  };

  const handleUpload = async () => {
    if (fileList.length === 0) {
      message.warning("Please select files");
      return;
    }

    setUploading(true); // ✅ START LOADER

    try {
      await uploadToServer(fileList);
    } finally {
      setUploading(false); // ✅ STOP LOADER
    }
  };

  // ================= DELETE =================
  const handleDelete = async (id) => {
    try {
      await Instance.delete(`/company/${companyId}/ndas/${id}`);
      message.success("Deleted");
      fetchDocuments();
    } catch {
      message.error("Delete failed");
    }
  };
  // Start editing
  const handleRenameClick = (doc) => {
    setEditingId(doc._id);
    setEditingName(doc.name);
  };

  // Save rename
  const handleRenameSave = async (docId) => {
    if (!editingName.trim()) {
      message.warning("File name cannot be empty");
      return;
    }

    try {
      await Instance.put(`/company/${companyId}/ndas/${docId}`, {
        name: editingName,
      });

      message.success("Renamed successfully");
      setEditingId(null);
      fetchDocuments();
    } catch {
      message.error("Rename failed");
    }
  };

  // Cancel rename
  const handleRenameCancel = () => {
    setEditingId(null);
    setEditingName("");
  };

  return (
    <div className="details-page mt-3">
      <h2>NDA Documents</h2>

      {/* 🔝 TOP BAR */}
      <div className="d-flex justify-content-end mb-4">
        {/* <Input
          placeholder="Search documents..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{ width: 300 }}
        /> */}

        <Button
          type="primary"
          icon={<UploadOutlined />}
          onClick={() => setIsModalOpen(true)}
        >
          Upload Document
        </Button>
      </div>

      {/* 📂 GRID VIEW */}
      {loading ? (
        <Spin />
      ) : (
        <>
          <div className="row">
            {documents.length > 0 ? (
              documents.map((doc) => (
                <div className="col-md-3 mb-3" key={doc._id}>
                  <div className="card p-2 shadow-sm">
                    {/* ✅ Preview */}
                    <div
                      style={{
                        height: 150,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        background: "#f5f5f5",
                        cursor: "pointer",
                      }}
                      onClick={() => window.open(doc.url, "_blank")}
                    >
                      {doc.resourceType.includes("image") ? (
                        <img
                          src={doc.thumbnail || doc.url}
                          alt=""
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      ) : (
                        <img
                          src={doc.thumbnail}
                          alt="pdf"
                          style={{ height: 150, width: "100%" }}
                        />
                      )}
                    </div>

                    {/* ✅ File Name */}
                    {/* File Name */}
                    {editingId === doc._id ? (
                      <Input
                        value={editingName}
                        autoFocus
                        size="small"
                        onChange={(e) => setEditingName(e.target.value)}
                        onPressEnter={() => handleRenameSave(doc._id)}
                        onBlur={handleRenameCancel}
                        onKeyDown={(e) => {
                          if (e.key === "Escape") handleRenameCancel();
                        }}
                      />
                    ) : (
                      <p
                        className="mt-2"
                        style={{
                          fontSize: "13px",
                          fontWeight: 500,
                          wordBreak: "break-word",
                        }}
                      >
                        {doc.name}
                      </p>
                    )}

                    {/* ✅ Actions */}
                    <div className="d-flex gap-2 justify-content-end align-items-center">
                      {/* Download */}
                      <a href={doc.url} download>
                        <DownloadOutlined />
                      </a>

                      {/* Rename */}
                      <span
                        style={{ cursor: "pointer" }}
                        onClick={() => handleRenameClick(doc)}
                      >
                        <EditOutlined />
                      </span>

                      {/* Delete */}
                      <DeleteOutlined
                        style={{ color: "red", cursor: "pointer" }}
                        onClick={() => handleDelete(doc._id)}
                      />
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <p>No documents found</p>
            )}
          </div>
          <div className="d-flex justify-content-end mt-3">
            <Pagination
              current={page}
              pageSize={limit}
              total={total}
              showSizeChanger={false}
              onChange={(p) => setPage(p)}
            />
          </div>
        </>
      )}

      {/* 📤 UPLOAD MODAL */}
      <Modal
        title="Upload Documents"
        open={isModalOpen}
        onCancel={() => {
          setIsModalOpen(false);
          setFileList([]);
        }}
        onOk={handleUpload}
        okText="Save"
        confirmLoading={uploading} // ✅ loader here
        okButtonProps={{ disabled: uploading }} // optional
      >
        <Dragger
          multiple
          fileList={fileList}
          beforeUpload={(file) => {
            const isLt1MB = file.size / 1024 / 1024 < 1;

            if (!isLt1MB) {
              message.error(`${file.name} exceeds 1MB limit`);
              return Upload.LIST_IGNORE; // ❌ prevents adding to list
            }

            return false; // ✅ keep file in list (manual upload)
          }}
          onChange={({ fileList }) => setFileList(fileList)}
        >
          <p className="ant-upload-drag-icon">
            <InboxOutlined />
          </p>
          <p>Click or drag files to upload</p>
        </Dragger>

        {fileList.length > 0 && (
          <div className="mt-3">
            <h5>Selected Files</h5>
            <div style={{ maxHeight: 150, overflowY: "auto" }}>
              {fileList.map((file) => (
                <div
                  key={file.uid}
                  className="d-flex justify-content-between mb-2"
                >
                  <span>{file.name}</span>
                  <Button
                    size="small"
                    danger
                    onClick={() =>
                      setFileList((prev) =>
                        prev.filter((f) => f.uid !== file.uid),
                      )
                    }
                  >
                    Remove
                  </Button>
                </div>
              ))}
            </div>
          </div>
        )}
      </Modal>

      {/* 🔥 DUPLICATE MODAL */}
      <Modal
        title="Duplicate Files Found"
        open={duplicateModal}
        onCancel={() => setDuplicateModal(false)}
        footer={null}
      >
        <p>These files already exist:</p>

        <ul>
          {duplicateFiles.map((f, i) => (
            <li key={i}>{f}</li>
          ))}
        </ul>

        <div className="d-flex gap-2 mt-3">
          <Button
            type="primary"
            onClick={() => {
              uploadToServer(pendingFiles, {
                replaceDuplicate: "true",
                skipDuplicateCheck: "false",
              });
              setDuplicateModal(false);
              setIsModalOpen(false);
            }}
          >
            Replace
          </Button>

          <Button
            onClick={() => {
              uploadToServer(pendingFiles, {
                skipDuplicateCheck: "true",
              });
              setDuplicateModal(false);
              setIsModalOpen(false);
            }}
          >
            Upload Anyway
          </Button>

          <Button
            onClick={() => {
              setDuplicateModal(false);
              setIsModalOpen(false);
            }}
          >
            Cancel
          </Button>
        </div>
      </Modal>
    </div>
  );
};
